import { render, staticRenderFns } from "./CashAccount.vue?vue&type=template&id=04cb4e98"
import script from "./CashAccount.vue?vue&type=script&lang=js"
export * from "./CashAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports